module.exports = __webpack_public_path__ + "img/4theplayer.9616f499.svg";